import { getTodayDate } from 'utils'

export const isOlderThan100Years = (year: number): boolean => {
  const today = getTodayDate()
  const currentYear = today.getFullYear()

  return currentYear - year > 100
}
